import { QueryHookOptions } from '@apollo/client';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import gql from 'graphql-tag';
import { KeywordQueryGq } from '../models/KeywordQueryGq';

export function useGetSelectedKeywordsStatsGq(
  command: CommandGq,
  options?: QueryHookOptions<SerpProgressGq, Variables>
) {
  // We provide a fallback while it's loading
  const fallback: GetSelectedKeywordsStatsGq = {
    selectedCount: 0,
    filteredCount: 0,
    selectedVolume: 0,
    selectedTaggedCount: 0,
    selectedNewRanksCount: 0,
    selectedUpdateRanksCount: 0,
    selectedUpdateRanksDates: ['', ''],
    selectedToEnglishCount: 0,
    selectedVolumeUpdateCount: 0,
    entireProjectCount: 0,
  };

  const query = useCustomQuery<SerpProgressGq, Variables>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
    ...options,
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getSelectedKeywordsStats ?? fallback,
  };
}

const gqTag = gql`
  query GetSelectedKeywordsStatsGq($command: GetSelectedKeywordsStatsCommand!) {
    projects {
      getSelectedKeywordsStats(command: $command) {
        filteredCount
        selectedCount
        selectedVolume
        selectedTaggedCount
        selectedNewRanksCount
        selectedUpdateRanksCount
        selectedUpdateRanksDates
        selectedToEnglishCount
        selectedVolumeUpdateCount
        entireProjectCount
      }
    }
  }
`;

interface SerpProgressGq {
  readonly projects: {
    readonly getSelectedKeywordsStats: GetSelectedKeywordsStatsGq;
  };
}

export interface GetSelectedKeywordsStatsGq {
  readonly filteredCount: number;
  readonly selectedCount: number;
  readonly selectedVolume: number;
  readonly selectedTaggedCount: number;
  readonly selectedNewRanksCount: number;
  readonly selectedUpdateRanksCount: number;
  readonly selectedUpdateRanksDates: string[];
  readonly selectedToEnglishCount: number;
  readonly selectedVolumeUpdateCount: number;
  readonly entireProjectCount: number;
}

export interface Variables {
  command: CommandGq;
}
export interface CommandGq {
  projectId: number;
  keywordQuery?: KeywordQueryGq;
}
